import React, {useContext, useEffect, useState} from "react"
import {renderForm} from "@components/Form/renderForm"
import {Box, Button} from "@mui/material"
import {
    assignPrizeManually,
} from "@api/games";
import {getAll} from "@api/benefits"
import {LoadingContext} from "@hoc/loading";
import {MessageContext} from "@hoc/messageNotification";
import Typography from "@mui/material/Typography";
import {validation} from "@services/validation";

export const PrizeManually = ({shopperId}) => {
    const {setLoading} = useContext(LoadingContext);
    const {setErrorMessage, setSuccessMessage} = useContext(MessageContext);
    const onCallback = (e) => {
        formValues.forEach((column) => {
            if (column.name === e.target.name) {
                column.value = e.target.value;
                column.error = '';
            }
        })

        setFormValues([...formValues]);
    }

    const data = [
        {
            name: 'benefitId',
            headerName: 'benefitId',
            value: '',
            error: '',
            label: 'Benefits',
            items: [],
            type: 'enum',
            onCallback
        },
        {
            name: 'languageIndex',
            headerName: 'languageIndex',
            value: '1',
            error: '',
            label: 'Language Index',
            items: ['1', '2'],
            type: 'enum',
            onCallback
        },
    ]

    const [formValues, setFormValues] = useState(data);
    const [benefits, setBenefits] = useState(data);

    const handleAssignPrize = async (e) => {
        e.preventDefault()
        try {
            setLoading(true);
            setErrorMessage(null);
            const objVal = {}
            formValues.forEach((formValue) => {
                objVal[formValue.name] = formValue.value;
            })

            const benefitId = benefits.find(({name}) => name === objVal['benefitId']).id

            const res = await assignPrizeManually({...objVal, benefitId, shopperId})
            setSuccessMessage(res)
        } catch (e) {
            validation(e, formValues, (columns) => {
                return setFormValues([...columns]);
            })
            setErrorMessage(e);
        }
        setLoading(false)
    }

    useEffect(() => {
        const loadBenefits = async () => {
            setLoading(true)
            try {
                const [benefits] = await getAll()
                const formBenefits = formValues.find(({name}) => name === 'benefitId')
                formBenefits.items = benefits.map(({name}) => name)
                setFormValues([...formValues]);
                setBenefits(benefits)
            } catch (e) {
                setErrorMessage(e)
            }
            setLoading(false)
        }

        loadBenefits();
    }, [setLoading, setErrorMessage])

    return (
        <Box sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center"
        }}>
            <Typography component="h4">Select Benefit</Typography>
            <Box component="form"
                 onSubmit={handleAssignPrize}
                 sx={{mt: 1, maxWidth: 200}}
                 noValidate>
                {formValues.map((data, key) => {
                    return renderForm(data, key);
                })}
                <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    sx={{mt: 3, mb: 2}}
                >
                    Assign Prize Manualy
                </Button>
            </Box>
        </Box>
    )
}